import { useInfiniteQuery } from 'react-query';
import { useContext } from 'react';
import { AuthContext } from "../../Context/AuthContext";

const fetchActiveDispatches = async ({ pageParam = 1 }, token, user) => {
  const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/packages/active-dispatches/${user.userId}?page=${pageParam}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Error fetching active dispatches');
  }

  return response.json();
};

const useActiveDispatches = () => {
  const { token, user } = useContext(AuthContext);
  return useInfiniteQuery(
    ['activeDispatches', user.userId], 
    ({ pageParam }) => fetchActiveDispatches({ pageParam }, token, user),
    {
      getNextPageParam: (lastPage) => {
        const nextPage = lastPage.currentPage + 1;
        return nextPage <= Math.ceil(lastPage.totalDispatches / 10) ? nextPage : undefined;
      },
    }
  );
};

export default useActiveDispatches;


